import React from 'react';

import { EditContactDialog } from '~/components/Contacts/UpsertContact/Edit/EditContactDialog';
import useFetchContact from '~/components/hooks/useFetchContact';
import LoadingIndicator from '~/components/LoadingIndicator';

interface ContactTfnEditDialogProps {
  contactId: number;
  onClose: () => void;
  onSave: () => void;
}

const ContactTfnEditDialog: React.FC<ContactTfnEditDialogProps> = ({ contactId, onClose, onSave }) => {
  const { isLoading, isError, data: contact } = useFetchContact(contactId);

  if (isLoading || !contact) {
    return <LoadingIndicator isError={isError} />;
  }

  const handleContactUpdate = () => {
    onSave();
    return Promise.resolve();
  };

  return (
    <EditContactDialog
      contact={contact}
      onClose={onClose}
      onContactUpdate={handleContactUpdate}
      title="Contact TFN Details"
      initialTabKey="au_tfn"
    />
  );
};

export default ContactTfnEditDialog;
